import { CurrentUser } from '@api/memberApi/interfaces';
import { MODULE_PERMISSIONS } from './module-permissions';
import { PERMISSIONS } from './permissions';

export const userCan = (
  user: CurrentUser,
  permission: string | string[]
): boolean => {
  if (user.isSuperAdmin) {
    return true;
  }

  if (Array.isArray(permission)) {
    return permission.some((entry) => user.permissions.includes(entry));
  }

  return user.permissions.includes(permission);
};

export const permissionsSignature = (user: CurrentUser): string => {
  return JSON.stringify({
    isSuperAdmin: user.isSuperAdmin,
    permissions: [...user.permissions].sort(),
  });
};

export const canAccessManagePath = (
  pathname: string,
  user: CurrentUser
): boolean => {
  if (!pathname.startsWith('/manage')) {
    return true;
  }

  if (user.isSuperAdmin) {
    return true;
  }

  if (pathname.startsWith('/manage/members')) {
    return userCan(user, PERMISSIONS.members.view);
  }

  if (pathname.startsWith('/manage/news')) {
    return userCan(user, PERMISSIONS.newsItems.view);
  }

  if (pathname.startsWith('/manage/competitions')) {
    return userCan(user, [
      PERMISSIONS.competitions.view,
      PERMISSIONS.competitions.disciplines.view,
    ]);
  }

  if (pathname.startsWith('/manage/association')) {
    return userCan(user, [
      PERMISSIONS.association.about.view,
      PERMISSIONS.association.instructions.view,
      PERMISSIONS.association.boardMembers.view,
      PERMISSIONS.association.rulesAndRegulationsPage.view,
      PERMISSIONS.association.weaponGroups.view,
    ]);
  }

  if (pathname.startsWith('/manage/roles-and-permissions')) {
    return userCan(user, PERMISSIONS.roles.view);
  }

  return MODULE_PERMISSIONS.some((permission) => userCan(user, permission));
};
